import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroBultosFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='N. BULTOS' htmlFor='input-numeroBultos' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='numeroBultos'>
          {({ field }) => <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-numeroBultos' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroBultosFormGroup)
